/* ════════════════════════════════════════════════════════════════════
   CIMA v3 · La tienda nueva (desde el prototipo, 7-oct-2026)
   El comportamiento del prototipo (`cima-prototipo/app.js`) sobre el pedido
   real de Shopify: las altas, cambios y bajas van a /cart/*.js y el panel se
   repinta pidiendo su sección (`?section_id=cima-v3-pedido`), así lo que se
   ve es siempre lo que el servidor confirmó.

   Reglas que vienen de la tienda v2 y se conservan:
   · Un POST confirmado no se repite: si el servidor ya respondió y no se
     puede pintar, se va a /cart (lee el estado real), nunca otro envío.
   · Sin respuesta (red caída) se manda el formulario nativo: el pedido no se
     pierde.
   · «Comprar ahora» (`name="return_to"`) pasa nativo, va al pago.
   · Un formulario con un envío en vuelo ignora el segundo toque.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ── Aviso flotante (toast del prototipo) ─────────────────────────── */
  var avisoT = 0;
  function avisar(txt) {
    var a = $('[data-aviso]');
    if (!a) return;
    a.textContent = txt; a.classList.add('is-in');
    clearTimeout(avisoT); avisoT = setTimeout(function () { a.classList.remove('is-in'); }, 2600);
  }

  /* ════════════════════════════════════════════════════════════════
     PANEL DEL PEDIDO
     ════════════════════════════════════════════════════════════════ */
  var panel = $('[data-panel]');
  var velo = $('[data-velo]');
  var abridor = null, cierreT = 0, ocupado = false, ultimoRepinte = 0;

  function fondo(inerte) {
    $$('body > *').forEach(function (el) {
      if (el.tagName === 'SCRIPT' || (panel && el.contains(panel))) return;
      if (el.querySelector && el.querySelector('[data-aviso]')) return;   // el aviso debe oírse con el panel abierto
      el.inert = inerte;
    });
    document.documentElement.style.overflow = inerte ? 'hidden' : '';
    document.body.style.overflow = inerte ? 'hidden' : '';
  }
  function focoPanel(sel) {
    /* Cerrado o cerrándose: no se roba el foco que ya volvió al abridor (un
       repintado o el temporizador de apertura que llegan tarde; Codex, 7-oct). */
    if (!panel || panel.hidden || cierreT) return;
    var b = sel && $(sel, panel);
    (b || $('[data-cerrar-pedido]', panel) || panel).focus();
  }
  function abrirPanel(desde) {
    if (!panel) return false;
    if (cierreT) { clearTimeout(cierreT); cierreT = 0; }
    else if (!panel.hidden) return true;
    abridor = desde || document.activeElement;
    panel.hidden = false; velo.hidden = false;
    fondo(true);
    requestAnimationFrame(function () { panel.classList.add('is-in'); velo.classList.add('is-in'); });
    setTimeout(function () { focoPanel(); }, 60);
    if (typeof revisarFija === 'function') revisarFija();
    /* El panel se dibuja con la página: si el pedido cambió por fuera (otra
       pestaña, «atrás» desde el pago), se pide el actual al abrir. Si
       acabamos de repintar (agregar), no hace falta. */
    if (Date.now() - ultimoRepinte > 1500) repintar().catch(function () {});
    return true;
  }
  function cerrarPanel(volver) {
    if (!panel || panel.hidden || cierreT) return;
    panel.classList.remove('is-in'); velo.classList.remove('is-in');
    fondo(false);
    var fin = function () { cierreT = 0; panel.hidden = true; velo.hidden = true; };
    if (reduce.matches) fin(); else cierreT = setTimeout(fin, 450);
    /* Primero la barra fija (quita su `inert`): si el panel se abrió desde
       ella, el foco tiene que poder volver a su botón. */
    if (typeof revisarFija === 'function') revisarFija();
    if (volver !== false && abridor && document.contains(abridor)) abridor.focus();
  }
  function irAlPedido() { window.location.assign(raiz + 'cart'); }

  /* Repinta el panel con la sección del servidor. `elegir(panel)` devuelve
     el selector a enfocar después; rechaza si la sección no llega entera. */
  var turnoRepinte = 0;
  function repintar(enfocar) {
    /* Solo pinta la respuesta del último pedido: si una vieja llega tarde
       (red lenta), dejaría cantidades viejas en los botones − y +. */
    var turno = ++turnoRepinte;
    return fetch(raiz + '?section_id=cima-v3-pedido', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('seccion'); return r.text(); })
      .then(function (html) {
        if (turno !== turnoRepinte) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nuevo = $('[data-panel]', tmp);
        if (!nuevo || !panel) throw new Error('seccion');
        panel.innerHTML = nuevo.innerHTML;
        ultimoRepinte = Date.now();
        var n = $('[data-panel-cuenta]', panel);
        var cuenta = n ? n.textContent.trim() : null;
        if (cuenta !== null) {
          $$('[data-cuenta]').forEach(function (c) { c.textContent = cuenta; });
          $$('[data-cuenta-txt]').forEach(function (c) { c.textContent = cuenta === '1' ? 'producto en tu pedido' : 'productos en tu pedido'; });
        }
        if (!panel.hidden) focoPanel(enfocar);
        if (typeof repintarEnvioFicha === 'function') repintarEnvioFicha();
      });
  }

  function animar(el, clase) { el.classList.remove(clase); void el.offsetWidth; el.classList.add(clase); }

  if (panel) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-abrir-pedido]');
      if (a) { e.preventDefault(); abrirPanel(a); }
    });
    velo.addEventListener('click', function () { cerrarPanel(); });
    document.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'Escape') { cerrarPanel(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, a[href], input, [tabindex]:not([tabindex="-1"])', panel).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    panel.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t) return;
      if (t.matches('[data-cerrar-pedido]')) { cerrarPanel(); return; }
      if (t.dataset.irPanel) {
        var dest = document.getElementById(t.dataset.irPanel);
        if (dest) { e.preventDefault(); cerrarPanel(false); irA(dest); }
        return;
      }
      if (!t.hasAttribute('data-cambiar')) return;
      e.preventDefault();
      if (ocupado) return;
      ocupado = true; panel.setAttribute('aria-busy', 'true'); t.disabled = true;
      var linea = t.dataset.cambiar, cant = Number(t.dataset.cantidad);
      var cual = t.classList.contains('linea__quitar') ? 'quitar' : (t.textContent.trim() === '+' ? 'mas' : 'menos');
      var enfocar = '[data-linea="' + linea + '"] ' + (cual === 'quitar' ? '.linea__quitar' : '[data-cambiar]' + (cual === 'mas' ? ':last-of-type' : ':first-of-type'));
      var respondio = false;
      fetch(raiz + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(t.dataset.clave ? { id: t.dataset.clave, quantity: cant } : { line: Number(linea), quantity: cant })
      })
        .then(function (r) {
          respondio = true;
          if (r.ok) return repintar(cant === 0 ? null : enfocar);
          return r.json().catch(function () { return {}; }).then(function (err) {
            return repintar(enfocar).then(function () { avisar((err && err.description) || 'No se pudo cambiar la cantidad.'); });
          });
        })
        .then(function () { ocupado = false; panel.removeAttribute('aria-busy'); })
        .catch(function () {
          ocupado = false; panel.removeAttribute('aria-busy'); t.disabled = false;
          if (respondio) irAlPedido(); else avisar('Sin conexión. Inténtalo de nuevo.');
        });
    });

    /* Formularios del panel que hablan con el pedido (la barra de envío:
       «Dejar solo lo que lleva envío incluido» y «Añadir … y llegas»). */
    panel.addEventListener('submit', function (e) {
      var f = e.target.closest('form');
      var accion = f && (f.getAttribute('action') || '');
      if (!f || !/\/cart\/(add|update|change)$/.test(accion)) return;
      e.preventDefault();
      if (ocupado) return;
      ocupado = true;
      var respondio = false;
      fetch(accion + '.js', { method: 'POST', body: new FormData(f), credentials: 'same-origin' })
        .then(function (r) { respondio = true; if (!r.ok) { ocupado = false; f.submit(); return; } return repintar(); })
        .then(function () { ocupado = false; })
        .catch(function () { ocupado = false; if (respondio) irAlPedido(); else f.submit(); });
    });
  }

  /* ── Agregar sin salir de la página ──────────────────────────────── */
  var PALOMITA = '<svg class="palomita" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4 10.5l4 4 8-9"/></svg>';
  function confirmarBoton(btn) {
    if (!btn) return;
    $$('.btn__ok', btn).forEach(function (n) { n.remove(); });
    var ok = document.createElement('span');
    ok.className = 'btn__ok'; ok.setAttribute('aria-hidden', 'true');
    ok.innerHTML = (btn.offsetWidth < 200 ? 'Agregado ' : 'Agregado a tu pedido ') + PALOMITA;
    btn.appendChild(ok); void ok.offsetWidth;
    btn.classList.add('is-ok');
    setTimeout(function () { btn.classList.remove('is-ok'); setTimeout(function () { ok.remove(); }, 400); }, 1600);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form');
    if (!f || !panel || panel.contains(f)) return;
    var accion = f.getAttribute('action') || '';
    if (!/\/cart\/add$/.test(accion)) return;
    if (!('submitter' in e)) return;                       // navegador viejo: nativo
    var sub = e.submitter;
    if (sub && sub.name === 'return_to') return;           // «Comprar ahora»: al pago
    e.preventDefault();
    if (f.hasAttribute('data-v3-enviando')) return;
    f.setAttribute('data-v3-enviando', '');
    var btn = sub || $('[type="submit"]', f);
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var listo = function () { f.removeAttribute('data-v3-enviando'); if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } };
    var datos = new FormData(f);
    var variante = datos.get('id');
    var respondio = false;
    fetch(raiz + 'cart/add.js', { method: 'POST', body: datos, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        respondio = true;
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (err) {
            listo(); avisar((err && err.description) || 'No se pudo agregar. Inténtalo de nuevo.');
          });
        }
        return repintar().then(function () {
          listo(); confirmarBoton(btn);
          var l = variante && $('[data-variante="' + String(variante).replace(/"/g, '') + '"]', panel);
          if (l) animar(l, 'is-nueva');
          if (!reduce.matches) $$('[data-cuenta]').forEach(function (c) { animar(c, 'is-salta'); });
          setTimeout(function () { abrirPanel(btn); }, reduce.matches ? 0 : 380);
        });
      })
      .catch(function () {
        if (respondio) { listo(); irAlPedido(); }
        else { f.removeAttribute('data-v3-enviando'); f.submit(); }
      });
  });
  /* Formularios fuera del panel que cambian el pedido (en la ficha de Kit:
     «Quitar la bolsa suelta de mi pedido»). Mismo trato que los del panel. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-v3-carrito]');
    if (!f || (panel && panel.contains(f))) return;
    e.preventDefault();
    if (f.hasAttribute('data-v3-enviando')) return;
    f.setAttribute('data-v3-enviando', '');
    var respondio = false;
    fetch(f.getAttribute('action') + '.js', { method: 'POST', body: new FormData(f), credentials: 'same-origin' })
      .then(function (r) {
        respondio = true;
        if (!r.ok) { f.submit(); return; }
        return repintar().then(function () { if (f.dataset.v3Aviso) avisar(f.dataset.v3Aviso); var c = $('[data-cta-principal]'); if (c) c.focus(); });
      })
      .catch(function () { if (respondio) irAlPedido(); else f.submit(); })
      .then(function () { f.removeAttribute('data-v3-enviando'); });
  });

  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    if (panel) repintar().catch(function () {});        // «atrás» desde el pago: contador y panel al día
    $$('form[data-v3-enviando]').forEach(function (fo) {
      fo.removeAttribute('data-v3-enviando');
      /* `fo.elements` incluye el botón de la barra fija, que vive fuera del form (form=) */
      Array.prototype.forEach.call(fo.elements, function (b) {
        if (b.getAttribute('aria-busy') === 'true') { b.disabled = false; b.removeAttribute('aria-busy'); }
      });
    });
  });
  /* Al volver atrás sin bfcache Safari puede restaurar el tamaño marcado
     (500 g) con el precio que pintó el servidor (250 g): se re-sincroniza. */
  function sincronizarTamano() {
    $$('[data-v3-tamano]:checked').forEach(function (r) {
      if (!r.defaultChecked) r.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  window.addEventListener('pageshow', sincronizarTamano);

  /* ── Tamaño en las tarjetas: precio del botón, tazas y foto ───────── */
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-v3-tamano]');
    if (!r) return;
    var card = r.closest('[data-cafe]');
    if (!card) return;
    /* En la ficha la barra fija, la galería y el aviso viven fuera de la caja de compra */
    var zona = r.closest('[data-v3-ficha]') || card;
    $$('[data-g]', zona).forEach(function (n) { n.textContent = r.dataset.vG; });
    $$('[data-precio-btn]', zona).forEach(function (n) { n.textContent = r.dataset.vPrecio; });
    $$('[data-precio]', zona).forEach(function (n) { n.textContent = r.dataset.vPrecio; });
    var tz = $('[data-taza]', card); if (tz && r.dataset.vTaza) tz.textContent = r.dataset.vTaza;
    $$('[data-tazas]', zona).forEach(function (n) { if (r.dataset.vTazas) n.textContent = r.dataset.vTazas; });
    $$('[data-foto-var]', card).forEach(function (n) { n.hidden = n.dataset.fotoVar !== r.value; });
    $$('[data-envio-var]', zona).forEach(function (n) { n.hidden = n.dataset.envioVar !== r.value; });
    $$('[data-cruce]', zona).forEach(function (n) { n.hidden = n.dataset.cruce !== r.value; });
    var item = $('[data-galeria-var="' + r.value + '"]', zona);
    if (item) irFoto(item.parentNode, Array.prototype.indexOf.call(item.parentNode.children, item));
  });

  /* ── Galería de la ficha: pista deslizable, puntos y miniaturas ───── */
  function marcarFoto(gal, i) {
    $$('[data-galeria-ir]', gal).forEach(function (b) { b.setAttribute('aria-current', String(Number(b.dataset.galeriaIr) === i)); });
  }
  function irFoto(pista, i) {
    var it = pista && pista.children[i];
    if (!it) return;
    pista.scrollTo({ left: it.offsetLeft - pista.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
    marcarFoto(pista.closest('[data-galeria]'), i);
  }
  $$('[data-galeria]').forEach(function (gal) {
    var pista = $('[data-galeria-pista]', gal);
    gal.addEventListener('click', function (e) { var b = e.target.closest('[data-galeria-ir]'); if (b) irFoto(pista, Number(b.dataset.galeriaIr)); });
    var t = 0;
    pista.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { marcarFoto(gal, Math.round(pista.scrollLeft / pista.clientWidth)); }, 80); }, { passive: true });
    /* Abre en la foto del tamaño que viene elegido */
    var marcado = $('[data-v3-ficha] [data-v3-tamano]:checked');
    var ini = marcado && $('[data-galeria-var="' + marcado.value + '"]', gal);
    if (ini) { var i0 = Array.prototype.indexOf.call(pista.children, ini); pista.scrollLeft = ini.offsetLeft - pista.offsetLeft; marcarFoto(gal, i0); }
  });

  /* ── Plegables (el widget de Judge.me en la ficha) ───────────────── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-v3-plegable]');
    if (!b) return;
    var c = document.getElementById(b.dataset.v3Plegable);
    if (!c) return;
    var abrir = c.hidden;
    c.hidden = !abrir; b.setAttribute('aria-expanded', String(abrir));
    if (abrir) {
      b.hidden = true;                                   // el botón se va: el foco pasa a lo que abrió
      if (!c.hasAttribute('tabindex')) c.setAttribute('tabindex', '-1');
      c.focus({ preventScroll: true });
    }
  });

  /* ── Barra fija de la ficha (celular) ────────────────────────────────
     Se ve siempre que el botón principal no esté entero a la vista, arriba
     o abajo; escondida, tampoco se alcanza con el tabulador. */
  var fija = $('[data-fija]');
  var ctaFija = fija && $('[data-cta-principal]');
  function revisarFija() {
    if (!fija || !ctaFija) return;
    var r = ctaFija.getBoundingClientRect();
    var entero = r.top >= -1 && r.bottom <= window.innerHeight + 1;
    var panelAbierto = panel && !panel.hidden && !cierreT;   // cerrándose cuenta como cerrado
    fija.classList.toggle('is-in', !entero && !panelAbierto);
    fija.inert = entero || panelAbierto;
  }
  if (fija && ctaFija) {
    fija.hidden = false;
    document.body.classList.add('con-fija');
    revisarFija();
  }

  /* El aviso de envío de la ficha depende del pedido: tras agregar se pide de nuevo */
  /* Solo pinta la respuesta del último pedido, y el tamaño se lee al llegar
     la respuesta, no al pedirla: si el cliente cambió de tamaño mientras
     tanto, el aviso es el del tamaño que tiene marcado (Codex, 7-oct). */
  var turnoEnvio = 0;
  function repintarEnvioFicha() {
    var f = $('[data-v3-ficha]');
    var caja = f && $('[data-envio-ficha]', f);
    if (!caja) return;
    var turno = ++turnoEnvio;
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(f.dataset.seccion), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html || turno !== turnoEnvio) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var nueva = $('[data-envio-ficha]', tmp);
        if (!nueva) return;
        caja.innerHTML = nueva.innerHTML;
        var marcado = $('[data-v3-tamano]:checked', f);
        if (marcado) $$('[data-envio-var]', caja).forEach(function (n) { n.hidden = n.dataset.envioVar !== marcado.value; });
      })
      .catch(function () {});
  }

  /* ── ¿Qué cafetera tienes? ───────────────────────────────────────── */
  $$('[data-cafetera]').forEach(function (box) {
    var res = $('[data-cafetera-r]', box);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cafetera-id]');
      if (!b) return;
      $$('[data-cafetera-id]', box).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var nombres = (b.dataset.nombres || '').split('|').filter(Boolean);
      if (!nombres.length) return;                       // chip sin cafés en el Personalizador
      var urls = (b.dataset.urls || '').split('|').filter(Boolean);
      var handles = (b.dataset.handles || '').split('|').filter(Boolean);
      var label = b.dataset.label.toLowerCase();
      var esc = function (s) { var d = document.createElement('span'); d.textContent = s; return d.innerHTML; };
      var intro = nombres.length > 1 ? 'Con ' + esc(label) + ' van bien los dos.' : 'Para ' + esc(label) + ' te recomendamos <b>' + esc(nombres[0] || '') + '</b>.';
      var ir;
      if (nombres.length > 1) {
        ir = res.dataset.duoUrl
          ? '<a class="btn btn--borde cafetera__ir" href="' + res.dataset.duoUrl + '">Ver ' + esc(res.dataset.duoNombre.trim()) + ', trae los dos <span class="btn__flecha" aria-hidden="true">→</span></a>'
          : '<a class="btn btn--borde cafetera__ir" href="#cafes-lista" data-ir="cafes-lista">Ver los dos cafés <span class="btn__flecha" aria-hidden="true">→</span></a>';
      } else {
        ir = '<a class="btn btn--borde cafetera__ir" href="' + urls[0] + '">Ver ' + esc(nombres[0] || '') + ' <span class="btn__flecha" aria-hidden="true">→</span></a>';
      }
      var guia = b.dataset.guiaUrl ? '<a class="link cafetera__guia" href="' + b.dataset.guiaUrl + '">' + esc(b.dataset.guia || '') + ' →</a>' : '';
      res.innerHTML = '<span class="js-r">' + intro + ' ' + esc(b.dataset.why || '') +
        (nombres.length === 1 ? ' La molienda media sirve en las cuatro cafeteras: lo demás es gusto.' : '') +
        '</span><span class="cafetera__acciones">' + ir + guia + '</span>';
      var seccion = box.closest('section') || document;
      $$('[data-tarjeta]', seccion).forEach(function (t) { t.classList.toggle('is-recomendada', handles.length === 1 && t.dataset.tarjeta === handles[0]); });
    });
  });

  /* ── Saltos dentro de la página (data-ir) ────────────────────────── */
  function irA(el) {
    el.tabIndex = -1; el.focus({ preventScroll: true });
    el.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ir]');
    if (!a || (panel && panel.contains(a))) return;
    var el = document.getElementById(a.dataset.ir);
    if (!el) return;                                        // otra página: el href lleva a la portada
    e.preventDefault(); irA(el);
  });
  /* Enlaces de la cabecera a /#cafes estando ya en la portada */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="/#"]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('href').slice(2));
    if (!el) return;
    e.preventDefault(); cerrarMenu(false); irA(el);
  });

  /* ── Reseñas y preguntas: «ver más» ──────────────────────────────── */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-resenas-mas]');
    if (rm) {
      var resto = $('[data-resenas-resto]', rm.closest('.envuelve'));
      resto.hidden = false; rm.hidden = true;
      $$('.rv', resto).forEach(function (x) { x.classList.add('is-in'); });
      var f = $('figure', resto); if (f) { f.tabIndex = -1; f.focus({ preventScroll: true }); }
      return;
    }
    var fq = e.target.closest('[data-faq-mas]');
    if (fq) {
      var r2 = $('[data-faq-resto]', fq.closest('.faq'));
      r2.hidden = false; fq.hidden = true;
      var s = $('summary', r2); if (s) s.focus({ preventScroll: true });
    }
  });

  /* ── Menú en celular ─────────────────────────────────────────────── */
  var menuBtn = $('[data-menu]'), menu = $('#menu-movil');
  function cerrarMenu(foco) {
    if (!menu || menu.hidden) return;
    menu.hidden = true; menuBtn.setAttribute('aria-expanded', 'false');
    if (foco) menuBtn.focus();
  }
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', function () {
      var abrir = menu.hidden;
      menu.hidden = !abrir; menuBtn.setAttribute('aria-expanded', String(abrir));
      if (abrir) { var l = $('a', menu); if (l) l.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('#menu-movil a')) { cerrarMenu(false); return; }
      if (!e.target.closest('#menu-movil, [data-menu]')) cerrarMenu(false);
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { e.stopPropagation(); cerrarMenu(true); } });
    window.matchMedia('(min-width: 768px)').addEventListener('change', function (e) {
      if (!e.matches) return;
      var i = $$('a', menu).indexOf(document.activeElement);
      cerrarMenu(false);
      if (i >= 0) { var d = $$('.cab__nav a')[i]; if (d) d.focus(); }
    });
  }

  /* ── Apariciones al entrar en pantalla ───────────────────────────── */
  (function () {
    var els = $$('.v3 .rv, .v3 .rv-img');
    if (reduce.matches || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var llego = false;
    var io = new IntersectionObserver(function (ents) {
      llego = true;
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 15% 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
    /* Red de seguridad: si el observador nunca entrega, nada se queda escondido. */
    setTimeout(function () {
      els.forEach(function (e) {
        if (e.classList.contains('is-in')) return;
        var r = e.getBoundingClientRect();
        if (!llego || (r.bottom > 0 && r.top < window.innerHeight)) e.classList.add('is-in');
      });
    }, 1500);
  })();

  /* ── Finca: el recorte de la foto sigue al scroll, sin secuestrarlo ─ */
  var finca = reduce.matches ? null : $('[data-finca]');
  function pintarFinca() {
    if (!finca) return;
    var r = finca.getBoundingClientRect();
    var vh = window.innerHeight;
    if (r.bottom < 0 || r.top > vh) return;
    var p = Math.min(1, Math.max(0, -r.top / (r.height - vh)));
    var abre = Math.min(1, p / 0.5);
    var ee = 1 - Math.pow(1 - abre, 3);
    var s = finca.style, movil = window.innerWidth < 768;
    s.setProperty('--iy', ((1 - ee) * (movil ? 22 : 18)) + '%');
    s.setProperty('--ix', ((1 - ee) * (movil ? 10 : 24)) + '%');
    s.setProperty('--s', String(1.18 - ee * 0.18));
    var t = Math.min(1, Math.max(0, (p - 0.12) / 0.28));
    s.setProperty('--t', t.toFixed(3));
    s.setProperty('--o', (0.35 + t * 0.65).toFixed(3));
    s.setProperty('--rot', Math.max(0, 1 - p * 4).toFixed(3));
  }

  /* Clip mudo de la cosecha: se pide al acercarse, no al cargar. */
  $$('[data-clip]').forEach(function (v) {
    if (!('IntersectionObserver' in window)) { v.poster = v.dataset.poster; return; }
    var io = new IntersectionObserver(function (es) {
      if (!es.some(function (x) { return x.isIntersecting; })) return;
      io.disconnect();
      v.poster = v.dataset.poster;
      if (reduce.matches) return;
      v.src = v.dataset.src;
      v.addEventListener('canplay', function () { v.play().catch(function () {}); }, { once: true });
      v.load();
    }, { rootMargin: '50% 0px' });
    io.observe(v.closest('.finca-tira') || v);
  });

  /* ── Fotos: se piden antes de llegar ───────────────────────────────
     Safari (iPhone) no pide una foto `loading="lazy"` hasta que casi entra
     en pantalla: al bajar rápido aparecía el hueco vacío y la foto después.
     Se piden pantalla y media antes; sin observador, el navegador decide. */
  if ('IntersectionObserver' in window) {
    var antes = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        /* Las fotos de una fila que se desliza quedan fuera del observador
           (las recorta su propio carril): van con su carril. Las escondidas
           (fotos de la otra bolsa en las tarjetas) no se piden. */
        var carril = e.target.closest('.kits, .finca-tira__fotos, .detras__chicas, [data-galeria-pista]');
        (carril ? $$('img[loading="lazy"]', carril) : []).concat([e.target]).forEach(function (i) {
          if (i.closest('[hidden], [class*="jdgm"]')) return;
          i.loading = 'eager';
          antes.unobserve(i);
        });
      });
    }, { rootMargin: '150% 0px 150% 0px' });
    $$('img[loading="lazy"]').forEach(function (i) {
      if (!i.closest('[hidden], [class*="jdgm"]')) antes.observe(i);
    });
  }

  /* ── Cabecera: se esconde al bajar y vuelve al subir ─────────────────
     En celular el dedo nunca baja en línea recta: cada pausa de lectura
     trae unos píxeles hacia arriba y el rebote del final de la página
     también. Con «4 px arriba = mostrar» la barra volvía a cada rato y
     parecía que bajaba con uno (Horacio, 7-oct). Ahora se esconde en cuanto
     sale de la franja y solo vuelve tras subir de verdad (64 px seguidos)
     o cerca del principio; el rebote del fondo no cuenta. */
  var cab = $('[data-cab]');
  var cabSec = cab && cab.closest('.v3-cab-sec');
  var ultimoY = window.scrollY, subido = 0, raf = 0;
  function alScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var y = window.scrollY;
      if (cab) {
        cab.classList.toggle('is-solida', y > 8);
        if (!reduce.matches) {
          var fondo = y + window.innerHeight >= document.documentElement.scrollHeight - 2;
          var d = y - ultimoY;
          subido = d < 0 && !fondo ? subido - d : 0;
          var oculta = cab.classList.contains('is-oculta');
          if (d > 0 && y > 160 && (!panel || panel.hidden) && (!menu || menu.hidden)) oculta = true;
          else if (y < 120 || (subido >= 64 && !fondo)) oculta = false;
          cab.classList.toggle('is-oculta', oculta);
          if (cabSec) cabSec.classList.toggle('is-oculta', oculta);
        }
      }
      ultimoY = y;
      pintarFinca();
      revisarFija();
    });
  }
  document.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', function () { pintarFinca(); revisarFija(); }, { passive: true });
  if (cab) cab.addEventListener('focusin', function () { cab.classList.remove('is-oculta'); if (cabSec) cabSec.classList.remove('is-oculta'); });
  pintarFinca();
})();
